import { createFileRoute } from '@tanstack/react-router'

import MagicLinkLogin from 'pages/MagicLinkLogin'

export const Route = createFileRoute('/magic/$id')({
  component: MagicLinkLogin,
})
